<app-access-item [pendingLetter]="invite().email[0]" [hideOverflow]="true">
  <app-access-item-header>
    <span>Pending Invite </span>
    <app-badge icon="/assets/icons/16/guest.svg" color="grey-50">Guest</app-badge>
  </app-access-item-header>
  <app-access-item-body> {{ invite().email }} </app-access-item-body>
  <app-access-item-cta>
    <app-gallery-share-context
      itemCta
      [currentAccessLevel]="inviteAccess()"
      [accessLevels]="inviteAccessLevels"
      [mode]="'member-invite'"
      (onChange)="changeInviteAccessLevel($event)"
      [disabled]="!galleryPermissions().can_edit"
      [type]="'gallery'"
    ></app-gallery-share-context>
  </app-access-item-cta>
</app-access-item>
